import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.85, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, light = false }) => (
  <p
    className={`text-xs uppercase tracking-[0.3em] font-semibold mb-5 ${
      light ? "text-gold-soft" : "text-gold"
    }`}
  >
    {children}
  </p>
);
